import React from "react";

import {
  Search,
  MousePointerClick,
  Users,
  TrendingUp,
} from "lucide-react";

const PROBLEMS = [
  {
    icon: Search,

    title: "Not showing up professionally online",

    body:
      "Customers compare businesses in seconds. Without a modern online presence, trust drops instantly.",
  },

  {
    icon: MousePointerClick,

    title: "Visitors don’t take action",

    body:
      "Many websites look decent but fail to generate calls, WhatsApp inquiries or real leads.",
  },

  {
    icon: Users,

    title: "Competitors are growing faster online",

    body:
      "Businesses with better websites and visibility are attracting the customers you could be getting.",
  },

  {
    icon: TrendingUp,

    title: "Your marketing isn’t converting properly",

    body:
      "Without a conversion-focused system, website visitors and ad traffic often turn into missed opportunities.",
  },
];

export default function Problem() {
  return (
    <section
      className="py-20 lg:py-28"
      data-testid="problem-section"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">

        {/* Heading */}
        <div className="max-w-3xl">

          <p className="text-xs uppercase tracking-[0.22em] font-bold text-[var(--gf-blue)]">
            The Problem
          </p>

          <h2 className="font-display mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight leading-[1.1]">

            A good business deserves
            <br />

            a strong{" "}

            <span className="text-[var(--gf-blue)]">
              online presence.
            </span>
          </h2>

          <p className="mt-5 text-lg text-[var(--gf-text-2)] leading-relaxed">
            Today, customers search online before they call, visit or book.
            But most local businesses still have outdated websites,
            weak Google visibility, or no proper conversion system in place.
          </p>
        </div>

        {/* Cards */}
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">

          {PROBLEMS.map((p, i) => (
            <div
              key={i}
              data-testid={`problem-card-${i}`}
              className="group bg-white rounded-2xl border border-[var(--gf-border)] p-6 hover:-translate-y-1 hover:gf-shadow-soft transition-all duration-300"
            >

              <div className="h-11 w-11 rounded-xl bg-blue-50 text-[var(--gf-blue)] flex items-center justify-center">

                <p.icon className="h-5 w-5" />
              </div>

              <h3 className="font-display mt-4 text-lg font-bold">
                {p.title}
              </h3>

              <p className="text-sm text-[var(--gf-text-2)] mt-2 leading-relaxed">
                {p.body}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
